import { ReactNode } from 'react'
import { IconButton, Typography, useTheme } from '@mui/material'

import { ArrowIcon } from 'src/assets/icons'

import { useStyles } from './styles'
import { Box } from '@mui/system'
import { FONTS } from 'src/constants'

interface ISettingsDropdownProps {
  text: string
  icon?: ReactNode
  onButtonClick?: () => void
  disabled?: boolean
}

const SettingsDropdown = ({ text, icon, onButtonClick, disabled }: ISettingsDropdownProps) => {
  const classes = useStyles({ disabled })
  const theme = useTheme()

  return (
    <div className={classes.dropdownWrapper}>
      <Box className={classes.dropdownLeftWrapper} onClick={!disabled ? onButtonClick : () => {}}>
        {icon && icon}
        <Typography
          sx={{
            margin: 0,
            fontSize: FONTS.SIZES.m,

            color: disabled ? theme.palette.custom.grey2 : theme.palette.custom.darkBlue2,
          }}
        >
          {text}
        </Typography>
      </Box>
      <IconButton
        disabled={disabled}
        onClick={onButtonClick}
        className={classes.dropdownIconWrapper}
      >
        <ArrowIcon
          fill={disabled ? theme.palette.custom.grey2 : theme.palette.custom.darkBlue2}
          className={classes.dropdownIcon}
        />
      </IconButton>
    </div>
  )
}

export { SettingsDropdown }
